import { useQuery } from '@tanstack/react-query';
import { queue, whatsapp } from './client.ts';

/**
 * Consultas que a casca inteira usa (menu e barra superior).
 *
 * São as únicas que voltam a buscar quando a janela ganha foco: o padrão do
 * painel desliga isso (`App.tsx`) para não disparar rajada de requisição, mas
 * "chegou resposta" e "o WhatsApp caiu" são exatamente o que se quer ver ao
 * voltar para a aba.
 */

export function useQueueSummary() {
  return useQuery({
    queryKey: ['queue', 'summary'],
    queryFn: queue.summary,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    staleTime: 10_000,
  });
}

export function useWhatsAppStatus() {
  return useQuery({
    queryKey: ['whatsapp', 'status'],
    queryFn: whatsapp.status,
    refetchInterval: 120_000,
    refetchOnWindowFocus: true,
    staleTime: 60_000,
    retry: false,
  });
}

export function useAiSpend() {
  return useQuery({
    queryKey: ['ai', 'spend'],
    queryFn: queue.aiSpend,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
    retry: false,
  });
}
